module.exports = __webpack_public_path__ + "img/20210325.b8105688.png";